
// import About from './components/About';
// import Footer from './components/Footer';
// import Home from './components/Home';
// import Navbar from './components/Navbar';

// function App() {
//   return (
//     <div className="App">
//      <Navbar/>
//      <Home/>
//      <About/>
//      <Footer/>
//     </div>
//   );
// }

// export default App;



import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./components/Home";
import About from "./components/About";
import Decants from "./pages/ Decants";
import BottleGuide from "./pages/ BottleGuide";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


function App() {
  return (
    <Router>
      <Routes>

        <Route path="/" element={
          <>
            <Navbar />
            <Home />
            <About />
            <Footer />
          </>
        } />

        <Route path="/decants" element={<Decants/>} />
        <Route path="/bottle-guide" element={<BottleGuide/>} />

      </Routes>
      <ToastContainer position="top-center" autoClose={5000} />
    </Router>
  );
}

export default App;
